export const NAVBAR_HEIGHT = 56;
export const NAVBAR_MARGIN = 8;
export const TIME_FILTER_HEIGHT = 36;
export const TIME_FILTER_MARGIN = 8;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/styles/elementConstants.ts